module.exports = __webpack_public_path__ + "static/img/equipment2new.c2ea8245.png";